import {
  areEquivalentBySubstitution,
  sameFormAnyOrder,
  sameFormSameOrder,
} from '@huoncroll/math-editors/marking';

export const normaliseMathAnswer = (value: string): string => {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return '';
  return trimmed.replace(/\s+/g, '');
};

export const areMathAnswersEquivalent = (userAnswer: string, acceptedAnswer: string): boolean => {
  const result = areEquivalentBySubstitution(userAnswer, acceptedAnswer, {
    testCount: 8,
    numericTolerance: 1e-6,
  });
  if (result.equivalent === true) return true;
  if (result.equivalent === false) return false;
  return sameFormAnyOrder(userAnswer, acceptedAnswer) || sameFormSameOrder(userAnswer, acceptedAnswer);
};
